import React from 'react';
import { OverflowMenu, OverflowMenuItem } from 'carbon-components-react';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';
import { Add16 } from '@carbon/icons-react';

export default function OverflowMenuIcon ({ stage, parseForm, configFile, userRol }) {
  const MenuItems = [];
  configFile.transitions.forEach(transition => {
    if (transition.roles.includes(userRol)) {
      stage.stages.map((value) => (
        transition.destination === value.id && transition.source === 'none' && MenuItems.push(
          <OverflowMenuItem key={transition.id} itemText={funcTranslateHelper(transition.nombre)} onClick={() => parseForm(transition)} />)
      ));
    }
  });

  return (
    <OverflowMenu renderIcon={Add16} className='stage-dropdown-button'>
      {stage.stages && MenuItems}
    </OverflowMenu>
  );
}
